import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from '../store';

/**
 * Typed useAppSelector hook
 * Use this instead of plain `useSelector` for type safety.
 *
 * @author Civilhealth Development Team
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;